export const getCurrentYearPeriods = (periodConfigurations) => {
    const today = new Date()
    const year = today.getUTCFullYear()
    const periodConfig = periodConfigurations?.find((x) => x.year === year)
    return periodConfig?.periods ?? []
}

